import { render, staticRenderFns } from "./TroskovnikSatnica.vue?vue&type=template&id=0879029a"
import script from "./TroskovnikSatnica.vue?vue&type=script&lang=js"
export * from "./TroskovnikSatnica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports